import axios from 'axios';
import { SiteOverview } from 'views/order-feed/features/my-supply-plan/types/ofd-sites.type';

// GET: Fetch OFD Sites
// /ewosapi/v1/order/overview?globalCompanyId=${globalCompanyId}
export const getSiteOverview = async (globalCompanyId: string, globalSiteIds: string[]): Promise<SiteOverview[]> => {
  // if (!isProductionEnvironment) return SiteOverviewData;
  const res = await axios.post<SiteOverview[]>(`/ewosapi/v1/order/overview?globalCompanyId=${globalCompanyId}`, {
    globalSiteIds: globalSiteIds,
  });
  return res.data;
};

// To make the MockData work the adressNumber and hasRecentOrders needs to be null checked instead of an none null assortment in updatedSiteList found in sites-overview.tsx
